import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ITeasersContext, TeasersContext } from '../../teasersState/teasersContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Teasers.module.scss';

const Teasers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, teasers, currentPage, countOfItems } = useContext<ITeasersContext>(TeasersContext);

	return (
		<>
			{teasers.teasersCount ? (
				<div className={style.container} data-test="Teasers">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={teasers.teasersCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Teasers;
